import { SortingDirection } from '../../models/sortingDirection.model';

// We need to switch from string constants to enum
// These are compatibility helper functions
export const stringOrderToEnumDirection = (orderDirection: string | undefined): SortingDirection | undefined => {
  if (orderDirection === 'asc') {
    return SortingDirection.ASC;
  }
  if (orderDirection === 'desc') {
    return SortingDirection.DESC;
  }
  return undefined;
};

export const enumDirectionToStringOrder = (sortingDirection: SortingDirection | undefined): 'asc' | 'desc' | '' => {
  if (sortingDirection === SortingDirection.ASC) {
    return 'asc';
  }
  if (sortingDirection === SortingDirection.DESC) {
    return 'desc';
  }
  return '';
};
